import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import CONFIG from "@rentiohq/shared/dist/config/app.config";

export const Wrap = styled.div`
  margin-top: 8px;
  margin-left: 8px;
  margin-right: 8px;

  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 0px;
  padding-right: 8px;

  background-color: ${props => props.theme.colors.global4};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: 24px;
    margin-right: 24px;

    padding-left: 6px;
    padding-right: 16px;

    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
`;

export const ButtonWrap = styled.button`
  display: block;
  width: 100%;
  padding: 0;
`;

export const InnerWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AppIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const TextWrap = styled.div`
  flex: 1;
  text-align: left;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-left: 6px;
    margin-right: 6px;
  }
`;

export const Title = styled.span`
  display: block;
  margin-bottom: 2px;
  font-size: 13px;
  font-weight: bold;
  color: ${props => props.theme.colors.neutral1};
`;

export const Subtitle = styled.span`
  display: block;
  font-size: 12px;
  color: ${props => props.theme.colors.neutral1};
`;

export const OpenAppButton = styled.button`
  padding: 0;
`;

export const OpenAppButtonText = styled.span`
  font-size: 14px;
  font-weight: bolder;
  color: ${props => props.theme.colors.global5};
`;
